// extracted by mini-css-extract-plugin
module.exports = {"light":"IX7WQwZCzaKix1_ha1U9","dark":"WXjShTzasRefJC5V8TPV","fa-spin":"BC3JfHrZC_sHLyyLafN3"};